import classNames from 'classnames'
import { ComponentProps, ElementType, ReactNode } from 'react'
import { Card } from '../../atoms'

type PropsOf<Tag = any> = Tag extends ElementType ? ComponentProps<Tag> : never

type SelectionCardProps<Tag> = {
  // as can be used to provide a custom element as the wrapper element, useful when for example
  // integrating with react-router links
  as?: Tag
  children: ReactNode
  disabled?: boolean
  selected?: boolean
  cardClassName?: string
} & PropsOf<Tag>

export const SelectedCard = <Tag extends React.ElementType<any> = 'button'>({
  as = 'button',
  children,
  disabled,
  selected,
  cardClassName,
  ...other
}: SelectionCardProps<Tag>) => {
  const Container = as
  return (
    <Container
      {...other}
      className={classNames(other.className, 'text-left')}
      onClick={!disabled ? other.onClick : undefined}
      to={!disabled ? other.to : undefined}
    >
      <Card
        hover
        selected={selected}
        className={classNames('p-4', disabled ? 'bg-gray-50! drop-shadow-none! cursor-not-allowed' : '', cardClassName)}
      >
        {children}
      </Card>
    </Container>
  )
}
